import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { Scroll } from "@lib/scroll";

export default function (element, dataset) {
  const toggle = element.querySelector('[data-match-toggle="tags"]');
  if (!toggle) return;

  window.FinsweetAttributes ||= [];
  window.FinsweetAttributes.push([
    "list",
    (listInstances) => {
      const listInstance = listInstances.find((item) => {
        return item.instance === "Articles";
      });

      if (!listInstance) return;

      let isAllMode = false;

      toggle.addEventListener("click", () => {
        isAllMode = !isAllMode;
        const mode = isAllMode ? "and" : "or";
        const label = toggle.querySelector(".pill_text");

        if (label) {
          gsap.to(label, {
            opacity: 0,
            filter: "blur(8px)",
            scale: 0.99,
            duration: 0.2,
            ease: "power2.in",
            onComplete: () => {
              label.textContent = isAllMode ? "All" : "Any";
              gsap.fromTo(
                label,
                { opacity: 0, filter: "blur(8px)", scale: 0.99 },
                {
                  opacity: 1,
                  filter: "blur(0px)",
                  scale: 1,
                  duration: 0.3,
                  ease: "power2.out",
                },
              );
            },
          });
        }

        const filters = listInstance.filters.value;

        for (const group of filters.groups) {
          for (const condition of group.conditions) {
            if (condition.fieldKey === "tags") {
              condition.filterMatch = mode;
            }
          }
        }

        listInstance.triggerHook("filter");
        Scroll.resize();
      });
    },
  ]);
}
